import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import largeLogo from "../assets/largeLogo.png";

function Navbar() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light">
      <NavLink
            className="nav-link "
            activeStyle={{ color: "" }}
            to="/"
          >
            
          
        <div className="navbar-brand text-info font-weight-bolder" >
          <img
            src={largeLogo}
            alt="Logo"
            width="43"
            height="40"
            className="vertical-align-middle"
            
          />
          
          <span className="">Steve Tornes</span>
        </div>
        </NavLink>
        <button
          className="custom-toggler navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar__links"
          aria-controls="navbar__links"
          aria-expanded={!isNavCollapsed ? true : false}
          aria-label="Toggle navigation"
          onClick={handleNavCollapse}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`${isNavCollapsed ? "collapse" : ""} navbar-collapse`}
          id="navbar__links"
        >
          
           <NavLink
            className="nav-link text-mainLink"
            activeStyle={{ color: "" }}
            to="/"
          >
            About
          </NavLink>
          <NavLink
            className="nav-link text-info"
            activeStyle={{ color: "" }}
            to="/charts"
          >
            Charts
          </NavLink>

          <NavLink
            className="nav-link text-info"
            activeclassname="active"
            to="/publications_and_presentations"
          >
            Publications and Presentations
          </NavLink>
          <NavLink
            className="nav-link text-info"
            activeStyle={{ color: "" }}
            to="/photography"
          >
            Photography
          </NavLink>
         
        </div>
      </nav>
    </>
  );
}
export default Navbar;
